
    import './styles.scoped.css';
    export default {
  "grid": "awsui_grid_14yj0_1abp6_3",
  "no-gutters": "awsui_no-gutters_14yj0_1abp6_16",
  "grid-column": "awsui_grid-column_14yj0_1abp6_20",
  "colspan-1": "awsui_colspan-1_14yj0_1abp6_29",
  "push-1": "awsui_push-1_14yj0_1abp6_33",
  "pull-1": "awsui_pull-1_14yj0_1abp6_36",
  "colspan-2": "awsui_colspan-2_14yj0_1abp6_39",
  "push-2": "awsui_push-2_14yj0_1abp6_43",
  "pull-2": "awsui_pull-2_14yj0_1abp6_46",
  "colspan-3": "awsui_colspan-3_14yj0_1abp6_49",
  "push-3": "awsui_push-3_14yj0_1abp6_53",
  "pull-3": "awsui_pull-3_14yj0_1abp6_56",
  "colspan-4": "awsui_colspan-4_14yj0_1abp6_59",
  "push-4": "awsui_push-4_14yj0_1abp6_63",
  "pull-4": "awsui_pull-4_14yj0_1abp6_66",
  "colspan-5": "awsui_colspan-5_14yj0_1abp6_69",
  "push-5": "awsui_push-5_14yj0_1abp6_73",
  "pull-5": "awsui_pull-5_14yj0_1abp6_76",
  "colspan-6": "awsui_colspan-6_14yj0_1abp6_79",
  "push-6": "awsui_push-6_14yj0_1abp6_83",
  "pull-6": "awsui_pull-6_14yj0_1abp6_86",
  "colspan-7": "awsui_colspan-7_14yj0_1abp6_89",
  "push-7": "awsui_push-7_14yj0_1abp6_93",
  "pull-7": "awsui_pull-7_14yj0_1abp6_96",
  "colspan-8": "awsui_colspan-8_14yj0_1abp6_99",
  "push-8": "awsui_push-8_14yj0_1abp6_103",
  "pull-8": "awsui_pull-8_14yj0_1abp6_106",
  "colspan-9": "awsui_colspan-9_14yj0_1abp6_109",
  "push-9": "awsui_push-9_14yj0_1abp6_113",
  "pull-9": "awsui_pull-9_14yj0_1abp6_116",
  "colspan-10": "awsui_colspan-10_14yj0_1abp6_119",
  "push-10": "awsui_push-10_14yj0_1abp6_123",
  "pull-10": "awsui_pull-10_14yj0_1abp6_126",
  "colspan-11": "awsui_colspan-11_14yj0_1abp6_129",
  "push-11": "awsui_push-11_14yj0_1abp6_133",
  "pull-11": "awsui_pull-11_14yj0_1abp6_136",
  "colspan-12": "awsui_colspan-12_14yj0_1abp6_139",
  "push-12": "awsui_push-12_14yj0_1abp6_143",
  "pull-12": "awsui_pull-12_14yj0_1abp6_146",
  "push-0": "awsui_push-0_14yj0_1abp6_149",
  "pull-0": "awsui_pull-0_14yj0_1abp6_152",
  "offset-1": "awsui_offset-1_14yj0_1abp6_155",
  "offset-2": "awsui_offset-2_14yj0_1abp6_158",
  "offset-3": "awsui_offset-3_14yj0_1abp6_161",
  "offset-4": "awsui_offset-4_14yj0_1abp6_164",
  "offset-5": "awsui_offset-5_14yj0_1abp6_167",
  "offset-6": "awsui_offset-6_14yj0_1abp6_170",
  "offset-7": "awsui_offset-7_14yj0_1abp6_173",
  "offset-8": "awsui_offset-8_14yj0_1abp6_176",
  "offset-9": "awsui_offset-9_14yj0_1abp6_179",
  "offset-10": "awsui_offset-10_14yj0_1abp6_182",
  "offset-11": "awsui_offset-11_14yj0_1abp6_185",
  "restore-pointer-events": "awsui_restore-pointer-events_14yj0_1abp6_189"
};
  